export default __webpack_public_path__ + "static/media/thumbnail.5bd78dcb.jpg";